import React, { useState } from 'react';
import { getApi } from '../../api/endpoints.js';
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants.js';
import ListingPageComponent from '../../components/ListingPageComponent.js';
import FiltersPartial from './FiltersPartial.js';
import Listing from  './Listing.js'
import Page from "../../pages/Page";
import PageContentWrapper from "../../components/PageContentWrapper";
import { useParams } from 'react-router-dom'

const PerSwapIndex = () => {
  const [filtersModel, setFiltersModel] = useState({});
  const params = useParams();
  const defaultHeaderConfig = { disableSort: false };
  const headers = [
    {
      ...defaultHeaderConfig,
      label: 'ID',
      attr: 'id',
    },
    {
      ...defaultHeaderConfig,
      label: 'Benificiary',
      value: (row) => {
        return <div className='d-block'>
          <div>
          ( {row.benifitiary_nomenclateure_id} ) -
          {row.benificiary_name} 
          </div>
        </div>
      },
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Customer',
      value: (row) => {
        return <div className='d-block'>
          <div>
          ( {row.customer_nomenclature_id} ) -
          {row.customer_name}
            
          </div>
        </div>
      },
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Offer Name',
      attr: 'offer_name',
      disableSort: true
    },

    {
      ...defaultHeaderConfig,
      label: 'Amount',
      attr: 'amount',
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'CS serial no',
      attr: 'charging_station_serial_no',
      disableSort: true
    },    {
      ...defaultHeaderConfig,
      label: 'Created At',
      attr: 'created_at',
      disableSort: false
    },
    {
      ...defaultHeaderConfig,
      label: 'Status',
      attr: 'status',
      disableSort: true
    },
    // {
    //   ...defaultHeaderConfig,
    //   label: 'Activated at',
    //   attr: 'activated_at',
    //   disableSort: false
    // },
    // {
    //   disableSort: false,
    //   label: 'Actions',
    //   value: (row) => {
    //     return <div style={{ display: 'flex', justifyContent: 'space-around' }}>
    //       <UiAction uiAction={uiManager.getUiAction(UI_ACTIONS.view_distributor_list.name)}>
    //         <div style={{ cursor: 'pointer' }} onClick={(e) => onViewClick(row.id)}>
    //           <FontAwesomeIcon icon={faEye} />
    //         </div>
    //       </UiAction>
    //     </div>
    //   }
    // }
  ]

  return <Page
      uiPage={uiManager.getUiPage(PAGES.PerDayEarningShowPage.name)}
      breadcrumbs={
        [ 
          { label: 'Home', url: '/dashboard' }, 
          { label: 'Partner Billings', url: '/partner_billings' }, 
          { label: `Partner Billing:${params.id}`, url: `/partner_billings/${params.id}` }, 
          { label: `Earnings for date ${params.date}` }
        ]
      }
      className={"earnings_listing-page"}
    >
        <Listing params={{to_date: params.date, from_date: params.date, partner_billing_id: params.id}} hideFilter={true}/>
    </Page>
};

export default PerSwapIndex;

